<template>
  <teleport to="body">
    <div v-if="alertStore.show" class="fixed inset-0 z-[9999]">
      <div class="fixed inset-0 bg-black opacity-50" @click="handleCancel"></div>
      <div class="fixed inset-0 flex items-center justify-center p-4">
        <div class="relative bg-white dark:bg-neutral-800 rounded-lg shadow-2xl w-full max-w-md p-6 z-10" @click.stop>
          
          <!-- Icon -->
          <div class="flex items-center justify-center mb-4">
            <div :class="[
              'w-12 h-12 rounded-full flex items-center justify-center',
              iconBgClass
            ]">
              <svg class="w-6 h-6" :class="iconColorClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="alertStore.type === 'success'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                <path v-else-if="alertStore.type === 'error'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                <path v-else-if="alertStore.type === 'warning'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          
          <!-- Title -->
          <h3 class="text-lg font-semibold text-center text-neutral-900 dark:text-white mb-2">
            {{ alertStore.title }}
          </h3>
          
          <!-- Message -->
          <p class="text-sm text-center text-neutral-600 dark:text-neutral-400 mb-6 whitespace-pre-line">
            {{ alertStore.message }}
          </p>
          
          <!-- Actions -->
          <div class="flex gap-3">
            <button
              v-if="alertStore.showCancel"
              @click="handleCancel"
              class="flex-1 px-4 py-2 border border-neutral-300 dark:border-neutral-600 rounded-md text-neutral-700 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-700 transition-colors"
            >
              {{ $t('common.cancel') }}
            </button>
            <button
              @click="handleConfirm"
              :class="[
                'px-4 py-2 rounded-md text-white transition-colors',
                alertStore.showCancel ? 'flex-1' : 'w-full',
                buttonClass
              ]"
            >
              {{ alertStore.showCancel ? $t('common.confirm') : $t('common.ok') }}
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useAlertStore } from '@/stores/alert'

const alertStore = useAlertStore()

const iconBgClass = computed(() => {
  switch (alertStore.type) {
    case 'success':
      return 'bg-green-100 dark:bg-green-900/30'
    case 'error':
      return 'bg-red-100 dark:bg-red-900/30'
    case 'warning':
      return 'bg-yellow-100 dark:bg-yellow-900/30'
    default:
      return 'bg-blue-100 dark:bg-blue-900/30'
  }
})

const iconColorClass = computed(() => {
  switch (alertStore.type) {
    case 'success':
      return 'text-green-600 dark:text-green-400'
    case 'error':
      return 'text-red-600 dark:text-red-400'
    case 'warning':
      return 'text-yellow-600 dark:text-yellow-400'
    default:
      return 'text-blue-600 dark:text-blue-400'
  }
})

const buttonClass = computed(() => {
  switch (alertStore.type) {
    case 'success':
      return 'bg-green-600 hover:bg-green-700'
    case 'error':
      return 'bg-red-600 hover:bg-red-700'
    case 'warning':
      return 'bg-yellow-600 hover:bg-yellow-700'
    default:
      return 'bg-blue-600 hover:bg-blue-700'
  }
})

function handleConfirm() {
  if (alertStore.confirmCallback) {
    alertStore.confirmCallback()
  }
}

function handleCancel() {
  if (alertStore.cancelCallback) {
    alertStore.cancelCallback()
  } else {
    alertStore.close()
  }
}
</script>

